import React from "react";
import {
  bgColor07,
  blackColor,
  blackShade19,
  blueColor04,
  border25,
  greyColor42,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { Box, Button, Stack, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import moment from "moment";
import SelectWithLabel from "../../../components/Input/SelectWithLabel";

function OrderSummaryFilterCard({
  onCancel,
  selectedSearch,
  setSelectedSearch,
  handleApply,
  error,
}) {
  const currentYear = moment().year();
  const YEARS = Array.from({ length: currentYear - 2022 + 1 }, (_, i) => ({
    label: 2022 + i, // Year as the label
    id: i + 1, // ID starting from 1
  }));

  const DATE_RANGE = [
    { id: 1, label: "15 days" },
    { id: 2, label: "3 months" },
    { id: 3, label: "6 months" },
  ];

  return (
    <Box sx={styles.card} position="absolute" top="100%" right={0}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: bgColor07,
          padding: "7px 15px",
          borderBottom: "1px solid " + greyColor42,
        }}
      >
        <Typography
          fontSize={12.5}
          color={blackShade19}
          fontWeight={600}
          lineHeight={1.5}
          mb="0"
        >
          Search Filter
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            fontSize={{ xs: 12, md: 12 }}
            color={blackShade19}
            fontWeight={600}
            lineHeight="20px"
            component={Button}
            sx={{
              textDecoration: "underline",
              cursor: "pointer",
              p: 0,
              textTransform: "none",
              "&:hover": {
                background: "transparent",
              },
            }}
            onClick={() => setSelectedSearch(null)}
          >
            Clear All
          </Typography>
          <Box
            sx={{
              backgroundColor: whiteColor,
              borderRadius: "50%",
              width: "26px",
              height: "26px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CloseRoundedIcon
              sx={{ fontSize: "15px", fontWeight: 700, cursor: "pointer" }}
              onClick={onCancel}
            />
          </Box>
        </Box>
      </Box>
      <Stack p="6px 15px 15px" gap={1}>
        <SelectWithLabel
          label={"Year"}
          value={selectedSearch?.year}
          onValueChange={(value) =>
            setSelectedSearch({ year: value, dateRange: "", type: "year" })
          }
          menuList={YEARS || []}
          rounded
          borderFull
        />
        <SelectWithLabel
          label={"Date Range"}
          value={selectedSearch?.dateRange}
          onValueChange={(value) =>
            // setSelectedSearch({ year: "", dateRange: value, type: "dateRange" })
            setSelectedSearch({ year: "", dateRange: value, type:value ==="15 days" ? "dateRange" :"month" })
          }
          menuList={DATE_RANGE || []}
          rounded
          borderFull
        />

        {error ? (
          <Typography
            variant="subtitle1"
            component="p"
            fontSize={12}
            fontWeight={500}
            color="red"
          >
            {error}
          </Typography>
        ) : null}

        <Box display="flex" justifyContent={"space-between"} gap={2} mt={1}>
          <Button
            sx={styles.actionBtn(whiteColor, blackShade19)}
            onClick={onCancel}
            // disabled={loader}
          >
            Cancel
          </Button>
          <Button
            sx={styles.actionBtn(blueColor04, whiteColor)}
            onClick={handleApply}
            // disabled={loader}
          >
            Apply
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}

export default OrderSummaryFilterCard;

const styles = {
  card: {
    width: { md: "320px", xs: "93vw" },
    mt: 1,
    backgroundColor: whiteColor,
    borderRadius: "8px",
    border: border25,
    boxShadow: "0 1px 3px rgb(49 49 49 / 15%)",
    zIndex: 10,
  },
  actionBtn: (bgColor, textcolor) => ({
    padding: { md: "4px 25px", xs: "6px 12px" },
    fontSize: "11px",
    fontWeight: 600,
    color: textcolor,
    backgroundColor: bgColor,
    border: "1px solid " + textcolor,
    "&:hover": {
      color: bgColor,
      backgroundColor: textcolor,
      border: "1px solid " + bgColor,
    },
  }),
};
